import { useQuery } from '@tanstack/react-query';
import { paynowClauseOptions } from '../../constants/paynowClauses';
export function usePaynowClauses(filter) {
    const { data, isLoading, isError } = useQuery(paynowClauseOptions.get(filter));
    return {
        paynowClauses: data ?? [],
        loadingPaynowClauses: isLoading,
        paynowClausesUnavailable: isError,
    };
}
